import { Tooltip } from '@mui/material';
import Iconify from 'src/components/iconify';
import Label, { LabelColor } from 'src/components/label';

export interface WarehouseBadgeProps {
  label: string;
  /** What the state means for the user and what follows from it. */
  hint: string;
  color: LabelColor;
  /** Iconify id. */
  icon: string;
  testId?: string;
}

/** A Warehouse state or category marker: a soft Label that explains itself on hover. */
export default function WarehouseBadge({
  label,
  hint,
  color,
  icon,
  testId,
}: WarehouseBadgeProps): JSX.Element {
  return (
    <Tooltip title={hint} describeChild arrow placement="top">
      <Label
        variant="soft"
        color={color}
        sx={{ textTransform: 'none', width: 'fit-content' }}
        startIcon={<Iconify icon={icon} />}
        data-testid={testId}
      >
        {label}
      </Label>
    </Tooltip>
  );
}
